export interface ILocation
{
    id:number;
    street1:string;
    street2?:string;
    city:string;
    state:string;
    zipCode:string;
    latitude:number;
    longitude:number;
}

export class Location implements ILocation
{
    constructor
    (
        public id: number,
        public street1: string,
        public city: string,
        public state: string,
        public zipCode: string,
        public latitude:number,
        public longitude:number,
    )
    {}

    street2?: string;
}

export class LocationInsert 
{
    constructor
    (
        public street1: string,
        public city: string,
        public state: string,
        public zipCode: string,
        public street2?: string
    )
    {}

    static create(location : ILocation) : LocationInsert
    {
        var l = new LocationInsert(location.street1,location.city,location.state,location.zipCode,location.street2);
        return l;
    }
}

export class LocationUpdate 
{
    constructor
    (
        public street1?: string,
        public city?: string,
        public state?: string,
        public zipCode?: string,
        public street2?: string
    )
    {}

    static create(location : ILocation) : LocationUpdate
    {
        var l = new LocationUpdate(location.street1,location.city,location.state,location.zipCode,location.street2);
        return l;
    }
}